import React from 'react';
import { Col } from 'react-bootstrap';

const InfoBanner = ({ children, positionIcon = 'center' }) => {
  return (
    <Col>
      <div className={`d-flex align-items-${positionIcon} gap-2 px-3 py-2 mb-4 bg-violet-light text-violet-hover rounded-1`}>
        <i className={`bi bi-info-circle fs-normal d-flex align-items-center`}></i>
        <div className="fs-7">
          {children}
        </div>
      </div>
    </Col>
  );
};

export default InfoBanner;